var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование торговой марки","resource":"trademarks","elements":_vm.elements,"add-message":"Торговая марка добавлена","edit-message":"Торговая марка изменена"},on:{"change":payload => (_vm.isChanged = payload)}})
}
var staticRenderFns = []

export { render, staticRenderFns }